import { ChatServicePromiseClient } from '@trustero/trustero-api-web/lib/chat/chat_grpc_web_pb'
import {
  SearchChatRequest,
  SearchChatResponse,
} from '@trustero/trustero-api-web/lib/chat/chat_pb'
import { useAuthorizedGrpcClient } from 'src/adapter'
import { useCallback } from 'react'

export const useSearchChats = (): ((
  query: string,
) => Promise<SearchChatResponse>) => {
  const client = useAuthorizedGrpcClient(ChatServicePromiseClient)

  return useCallback(
    async (query: string) => {
      const request = new SearchChatRequest().setQuery(query)
      return await client.searchChats(request)
    },
    [client],
  )
}
